<!-- eslint-disable vue/valid-v-model -->
<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
  <div class="pa-2">
    <block v-if="loading"></block>

    <v-card flat class="pa-4 bar">
      <div class="d-flex justify-space-between align-center">
        <div>
          <TooltipBtn
            v-if="editing && $store.getters['rolesUser/getCustomRole'](199)"
           label="Eliminar Partida"
            color="error"
            @click.prevent="confirmDeleteAccountingEntry"
            :btnStyle="'margin-right: 0.3rem;'"
          >
            <v-icon> mdi-delete </v-icon>
          </TooltipBtn>
        </div>
        <div>
          <TooltipBtn
            v-if="editing && !allowEditing && $store.getters['rolesUser/getCustomRole'](198)"
            color="primary"
            :btnStyle="'margin-right: 0.3rem;'"
            @click="exportarPartidasDetalladas()"
            :label="'Exportar reporte detallado a pdf'"
          >
            <v-icon>mdi-file-pdf-box</v-icon>
          </TooltipBtn>
          <TooltipBtn
            v-if="editing && !allowEditing && $store.getters['rolesUser/getCustomRole'](198)"
            color="warning"
            :btnStyle="'margin-right: 0.3rem;'"
            :label="'Duplicar Partida'"
            @click="duplicateAccountingItem"
          >
              <v-icon>mdi-file-multiple</v-icon>
          </TooltipBtn>
          <TooltipBtn
            v-if="editing && !allowEditing && $store.getters['rolesUser/getCustomRole'](198)"
            color="primary"
            style="margin-right: 0.3rem;"
            :btnStyle="'margin-right: 0.3rem;'"
            :label="'Imprimir Partida'"
            @click="exportPdf"
          >
                <v-icon>mdi-printer</v-icon>
          </TooltipBtn>
          <TooltipBtn
            v-if="editing && !allowEditing && $store.getters"
            class="btn-save"
            :btnStyle="'margin-right: 0.3rem;'"
            label="Descargar partida en Excel"
            @click="confirmDownloadCurrentEntryExcel"
          >
  <v-icon>mdi-microsoft-excel</v-icon>
</TooltipBtn>

          <TooltipBtn
            v-if="editing && !allowEditing && $store.getters['rolesUser/getCustomRole'](198)"
            color="primary"
            :btnStyle="'margin-right: 0.3rem;'"
            :label="'Editar Partida'"
            @click="enableEditing"
          >
              <v-icon>mdi-pencil</v-icon>
          </TooltipBtn>
          <v-btn v-if="$store.getters['rolesUser/getCustomRole'](196) && (!win.meta?.accountingEntryToModify && !editing)"
            legaln
            small
            color="btn-save"
            style="margin-right: 0.3rem"
            @click.prevent="
              showHistory = true;
              keyHistory++;
            "
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn v-if="!win.meta?.accountingEntryToModify"
            small
            color="btnclean"
            style="margin-right: 0.3rem"
            @click.prevent="confirmCleanAccountingEntryForm"
          >
            <v-icon>mdi-broom</v-icon>
          </v-btn>
  <TooltipBtn
  v-if="!cannotEdit"
  color="primary"
  :btnStyle="'margin-right: 0.3rem;'"
  label="Importar partida contable desde Excel"
  @click="triggerExcelImport"
>
  <v-icon>mdi-file-excel</v-icon>
</TooltipBtn>
<TooltipBtn
  v-if="!cannotEdit"
  color="success"
  :btnStyle="'margin-right: 0.3rem;'"
  label="Descargar plantilla de partida contable para importar en Excel"
  @click="downloadExcelTemplate"
>
  <v-icon>mdi-download</v-icon>
</TooltipBtn>
<input
  ref="excelInput"
  type="file"
  accept=".xlsx,.xls"
  style="display:none"
  @change="handleExcelImport"
/>
          <TooltipBtn :btnClass="'btn-save'" :label="'Guardar Partida'" @click.prevent="saveAccountingEntry" 
            v-if="$store.getters['rolesUser/getCustomRole'](197)">
            <v-icon> mdi-content-save </v-icon>
          </TooltipBtn>
        </div>
      </div>
    </v-card>
    <div class="d-flex flex-wrap align-self-center justify-left mb-3 mt-5">
      <h1><b>Partida contable</b></h1>
    </div>
    <div v-if="form.ID_Accounting_item && cannotEdit" class="d-flex flex-wrap align-self-center justify-left mb-3 mt-5">
      <h4>Correlativo: <b>{{ form.ID_Accounting_item }}</b></h4>
    </div>
    <!-- <div v-if="form.ID_Accounting_item && !cannotEdit" class="d-flex flex-wrap align-self-center justify-left mb-3 mt-5">
      <h4>Correlativo: <b>{{ getCorrelative(form.ID_Accounting_item) }}</b></h4>
    </div> -->
    <v-form ref="accountingEntryForm" v-model="valid">
      <v-row class="mt-2">
        <v-col cols="12" md="3">
          <date-picker
            label="Fecha"
            @dateSelected="changueD"
            v-model="date"
            :value="date"
            :disbaled="cannotEdit"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Concepto"
            v-model="form.concept"
            outlined
            :rules="[(v) => !!v || 'Este campo es requerido']"
            required
            clearable
            dense
            :disabled="cannotEdit"
            maxLength="250"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Tipo"
            v-model="form.type"
            attach
            outlined
            :rules="[(v) => !!v || 'Este campo es requerido']"
            required
            id="jumper"
            dense
            clearable
            item-value="id_accounting_entry_type"
            item-text="accounting_entry_name"
            :items="TypesItems"
            :disabled="cannotEdit"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="!cannotEdit">
        <v-col cols="12" md="6">
          <v-text-field
            label="Correlativo"
            v-model="form.correlative"
            outlined
            :rules="[correlativeNumberRule]"
            maxlength = "6"
            clearable
            dense
            :disabled="cannotEdit"
          ></v-text-field>
          <p v-if="lastAccountingCorrelative">Ultimo correlativo agregado: {{ lastAccountingCorrelative }}</p>
        </v-col>
        <v-col cols="12" md="6">
          <h4 v-if="form.correlative">Nuevo correlativo: <b>{{ getCorrelative(form.correlative) }}</b></h4>
        </v-col>
      </v-row>
    </v-form>
    <div>
      <!-- Table 4 start - Services -->
      
       
          <v-col col="6">
            <v-btn :disabled="cannotEdit" class="btn-save" @click.prevent.stop="addAccount" >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </v-col>
        
          <div style="overflow-x: scroll;">
            <table id="detailstable">
              <tr>
                <th v-for="({ readableName }, index) in tableHeaders" :key="index">
                  {{readableName}}
                </th>
              </tr>
              <tr v-for="(element, index) in AcountList" :key="index">
                <td v-for="({ dbName, editable, events, link, style }, headerIndex) in tableHeaders" :key="headerIndex" :class="[link ? 'd-flex justify-center' : '', dbName === 'account_code' ? 'account-code-cell' : '']" >
                  <input v-if="editable"
                  :type="dbName === 'Deb' || dbName === 'Hab'? 'number': 'text'" 
                  maxlength="250" class="tableinput" v-model="AcountList[ index ][ dbName ]" v-on="{ ...throughEvents( events, index ) }" :readonly="true" :disabled="cannotEdit" :style="style ? style : {}" />
                  <a v-if="!cannotEdit && !editable && link === 1" href="#" class="mx-1" @click="chooseAccount( index )" v-on="{ ...throughEvents( events, index ) }">
                    <v-icon>mdi-magnify</v-icon>
                  </a>
                  <a v-if="!cannotEdit && !editable && link === 2" href="#" small color="btndelete" @click="confirmDeleteAccountingEntryDetail( index )" v-on="{ ...throughEvents( events, index ) }">
                    <v-icon color="error"> mdi-delete </v-icon>
                  </a>
                  <div v-if="!editable && !link" :style="{ ...style ? style : {}, display: 'inline-block'}" >
                    {{ AcountList[ index ][ dbName ] }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="shouldShowAccountSuggestions()" class="account-suggestions" :style="accountSuggestionsStyle">
            <button
              v-for="(account, suggestionIndex) in accountSuggestions"
              :key="account.id_account"
              type="button"
              class="account-suggestion-item"
              :class="{ 'account-suggestion-active': suggestionIndex === activeAccountSuggestionIndex }"
              @mousedown.prevent="selectAccountSuggestion(accountSuggestionRowIndex, account)"
              @mouseenter="activeAccountSuggestionIndex = suggestionIndex"
            >
              <span class="account-suggestion-code">{{ account.account_code }}</span>
              <span class="account-suggestion-name">{{ account.account_description }}</span>
            </button>
          </div>

    </div>
    <v-row>
      <v-col cols="12" md="4">
        <v-card-title> Total Debe: {{ Currency }}{{ Totals.TotalDebe }} </v-card-title>
      </v-col>
      <v-col cols="12" md="4">
        <v-card-title> Total Haber: {{ Currency }}{{ Totals.TotalHaber }} </v-card-title>
      </v-col>
      <v-col cols="12" md="4">
        <v-card-title v-if="Totals.Total == 0 || Totals.Total == '0.00'">
          Diferencia: {{ Currency }}{{ Totals.Total }}
        </v-card-title>
        <v-card-title v-else style="color: red">
          Diferencia: {{ Currency }}{{ Totals.Total }}
        </v-card-title>
      </v-col>
    </v-row>

    <!-- Show  Modal -->
    <v-dialog v-model="showModel" width="90%">
      <v-card style="height: 80vh !important; overflow-y: auto;">
        <AccountingItemForm :win="win" v-on:sendSelection="reaciveSelection" 
        v-on:closeDialog="showModel = false" :key="keyModel"
        />
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="showModelToChoose" width="60%">
      <v-card>
        <AccountingItemForm :win="win" v-on:sendSelection="reaciveSelection" />
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="showHistory" scrollable width="90%">
      <v-card style="height: 80vh !important; overflow-y: auto;">
        <AcountItemHistory
          v-on:sendetails="setupvalues"
          :key="keyHistory"
          :win="win"
          :entryTypes="TypesItems"
        />
      </v-card>
    </v-dialog>

    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
    <v-dialog v-model="showExcelConfirmDialog" max-width="500px">
  <v-card>
    <v-card-title class="text-h6">
      Descargar Excel
    </v-card-title>

    <v-card-text>
      ¿Desea incluir en el archivo de Excel el encabezado de la plantilla?
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        color="grey"
        text
        @click="confirmDownloadWithoutHeader"
      >
        No
      </v-btn>

      <v-btn
        color="primary"
        @click="confirmDownloadWithHeader"
      >
        Sí
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
        <PrintReportePartidasDetallado :dataProps="print"></PrintReportePartidasDetallado>

  </div>
</template>

<script>

import DatePicker from "@/components/DatePicker";
import AccountingItemForm from "./AccountingItemForm.vue";
import AcountItemHistory from "./AcountItemHistory.vue";
import Alerts from "@/components/Alerts";
import { mapState } from "vuex";
import { printToExcel } from "@/helpers/printToexcel";
import { formatDateV2 } from "../../../helpers/formatDate";
import Block from "@/components/Block";
import moment from 'moment';
import TooltipBtn from "../../../components/TooltipBtn.vue";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import PrintReportePartidasDetallado from "../../../components/ReportsAndPrintings/PrintReportePartidasDetallado.vue";
// import Vue from 'vue'

export default {
  name: "AccountingItem",
  props: ["win"],
  components: {
    // DxDataGrid,
    // DxKeyboardNavigation,
    // DxColumn,
    // DxPager,
    DatePicker,
    // DxPaging,
    // DxScrolling,
    AccountingItemForm,
    // DxEditing,
    // DxPatternRule,
    Alerts,
    Block,
    AcountItemHistory,
    TooltipBtn,
    PrintReportePartidasDetallado,
    // DxTextBox
    /*  DxExport, */

  },

  data() {
    return {
      correlativeNumberRule: v  => {
        if (!v) return true;
        if (isNaN(v)) return 'El número de correlativo no debe contener letras.';
        if (!isNaN(parseInt(v)) && v.toString().length <= 6) return true;
        return 'El número de correlativo puede contener como maximo 6 digitos.';
      },
      AccountListN: [],
      print: {
        show: false,
        data: [],
        header: {},
      },
      editing: false,
      preventEnterCounter: 0,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      
      },
      tab: null,
      focusedRowKey: 0,
      panel: 0,
      tag: true,
      form: {},
      TypesItems: [
        { name: "Debe", value: "Debe" },
        { name: "Haber", value: "Haber" },
      ],
      detailTypes: [],
     
      keyField: "id",
      loading: false,
      AcountList: [],
      defaultAccountItem: {
        "Deb": (0).toFixed(2),
        "Hab": (0).toFixed(2),
        "isDefault": true,
      },
      lastAccountingCorrelative: '',
      allowEditing: false,
      targetIndex: null,
      AcountItem: null,
      showHistory: false,
      search: {
        filter: null,
      },
      date: null,
      showModel: false,
      header: [],
      keyHistory: 0,
      changue: false,
      Totals: {
        TotalDebe: 0,
        TotalHaber: 0,
        Total: 0,
      },
      keyModel: 0,
      valid: false,
      showExcelConfirmDialog: false,
      AcountListN: [],
      RemovedAccountList: [],
      selectedToDelete: null,
      selectedToAssign: null,
      Currency: JSON.parse(localStorage.getItem("branch")).Currency,
      editableFieldsList: [
        "account_code",
        "concept",
        "Deb",
        "Hab",
        "Comentario"
      ],
      deleteByEnter: false,
      openCatalogByEnter: false,
      navigatingThroughInputs: false,
      accountSuggestionRowIndex: null,
      accountSuggestions: [],
      activeAccountSuggestionIndex: 0,
      accountSuggestionSelectionPending: false,
      accountSuggestionsStyle: {},
      tableHeaders: [
        {
          readableName: '',
          dbName: '',
          editable: false,
          link: 1,
          events: {
            keyup: (index, e) => {
              if ( e.key === 'ArrowRight' ) {
                this.navigateThroughInputs( e.target, 1 );
              } else if ( e.key === 'ArrowLeft' ) {
                this.navigateThroughInputs( e.target, 0 );
              }
            },
          }
        },
        {
          readableName: 'Código',
          dbName: 'account_code',
          editable: true,
          events: {
            blur: (index, e) => {
              if( !this.navigatingThroughInputs ) {
                this.accountCodeTyped( index );
                this.disableInput( e.target );
              }
            },
            input: (index, e) => {
              this.updateAccountSuggestions(index, e.target.value, e.target);
            },
            keydown: (index, e) => {
              this.handleAccountSuggestionKeydown(index, e);
            },
            keyup: (index, e) => {
              const currentElement = e.target;

              if(currentElement.hasAttribute( "readonly" )) {
                if ( e.key === 'ArrowRight' ) {
                  this.navigateThroughInputs( e.target, 1 );
                } else if ( e.key === 'ArrowLeft' ) {
                  this.navigateThroughInputs( e.target, 0 );
                } else if( e.key != 'Tab' ) {
                  this.enableInput( e.target );    
                }
              } else if( e.key === 'Enter' ) {
                if (this.accountSuggestionSelectionPending) {
                  this.accountSuggestionSelectionPending = false;
                  this.navigateThroughInputs( e.target, 1 );
                  return;
                }
                this.accountCodeTyped(index);
                this.navigateThroughInputs( e.target, 1 );
              }
            },
            keypress: ( index, e ) => {
              this.enableInput( e.target );
            },
            click: ( index, e ) => {
              this.enableInput( e.target );
              this.updateAccountSuggestions(index, e.target.value, e.target);
            }
          },
          style: {
            width: '100px !important'
          }
        },
        {
          readableName: 'Nombre',
          dbName: 'account_description',
          style: {
            width: '250px !important'
          }
        },
        {
          readableName: 'Concepto',
          dbName: 'concept',
          editable: true,
          events: {
            blur: (index, e) => {
              this.disableInput( e.target );
            },
            keyup: (index, e) => {
              const currentElement = e.target;

              if(currentElement.hasAttribute( "readonly" )) {
                if ( e.key === 'ArrowRight' ) {
                  this.navigateThroughInputs( e.target, 1 );
                } else if ( e.key === 'ArrowLeft' ) {
                  this.navigateThroughInputs( e.target, 0 );
                } else if( e.key != 'Tab' ) {
                  this.enableInput( e.target );    
                }
              } else if( e.key === 'Enter' ) {
                this.navigateThroughInputs( e.target, 1 );
              }
            },
            keypress: ( index, e ) => {
              this.enableInput( e.target );
            },
            click: ( index, e ) => {
              this.enableInput( e.target );
            }
          },
          style: {
            width: '250px !important'
          }
        },
        {
          readableName: 'Debe',
          dbName: 'Deb',
          editable: true,
          events: {
            blur: (index, e) => {
              this.formatValuesOnBlur( index, 'Deb' );
              this.disableInput( e.target );
            },
            keyup: (index, e) => {
              const currentElement = e.target;

              if(currentElement.hasAttribute( "readonly" )) {
                if ( e.key === 'ArrowRight' ) {
                  this.navigateThroughInputs( e.target, 1 );
                } else if ( e.key === 'ArrowLeft' ) {
                  this.navigateThroughInputs( e.target, 0 );
                } else if( e.key != 'Tab' ) {
                  this.enableInput( e.target );    
                }
              } else if( e.key === 'Enter' ) {
                this.navigateThroughInputs( e.target, 1 );
              }
            },
            keypress: ( index, e ) => {
              this.enableInput( e.target );
            },
            click: ( index, e ) => {
              this.enableInput( e.target );
            }
          },
          style: {
            width: '150px !important'
          }
        },
        {
          readableName: 'Haber',
          dbName: 'Hab',
          editable: true,
          events: {
            blur: (index, e) => {
              this.formatValuesOnBlur( index, 'Hab' );
              this.disableInput( e.target );
            },
            keyup: (index, e) => {
              const currentElement = e.target;

              if(currentElement.hasAttribute( "readonly" )) {
                if ( e.key === 'ArrowRight' ) {
                  this.navigateThroughInputs( e.target, 1 );
                } else if ( e.key === 'ArrowLeft' ) {
                  this.navigateThroughInputs( e.target, 0 );
                } else if( e.key != 'Tab' ) {
                  this.enableInput( e.target );    
                }
              } else if( e.key === 'Enter' ) {
                this.navigateThroughInputs( e.target, 1 );
              }
            },
            keypress: ( index, e ) => {
              this.enableInput( e.target );
            },
            click: ( index, e ) => {
              this.enableInput( e.target );
            }
          },
          style: {
            width: '150px !important'
          }
        },
        {
          readableName: '',
          dbName: '',
          editable: false,
          link: 2,
          events: {
            keyup: (index, e) => {

              if ( e.key === 'ArrowRight' ) {
                this.navigateThroughInputs( e.target, 1 );
              } else if ( e.key === 'ArrowLeft' ) {
                this.navigateThroughInputs( e.target, 0 );
              }
            },
          }
        },
      ]
    };
  },
  watch: {
    showModel() {
      if (!this.showModel) {
        // document.getElementById('jumper').addEventListener('keydown',this.checkTab);
        
        this.closeAccountsCatalog();
        this.closeDialog();
      }
    },
    AcountList: {
      handler: function () {
        this.Totals.TotalDebe = this.SumDeb();
        this.Totals.TotalHaber = this.SumHab();
        this.Totals.Total = this.TotalAcount();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    cannotEdit(){
      return this.editing && !this.allowEditing;
    },
    dialogWidth() {

return this.$vuetify.breakpoint.smAndDown ? '85%' : '65%';
}
  },
  beforeDestroy() {
    document.removeEventListener("keydown");
  },

  async mounted() {
    // console.log('this.win.meta.accountingEntryToModify ', this.win.meta.accountingEntryToModify);
    

    
    try {
      this.loading = true;
      this.defaultAlert = { ...this.alert };
      this.AcountList.push( { ...this.defaultAccountItem } );
      // console.log(JSON.parse(localStorage.getItem("branch")).Currency);
      this.getAcounteringType();
      await this.getAllAcounts();
      
      this.getAccountingDetailTypes();
      this.$store.dispatch("rolesUser/getAllRoles");
      this.typebusiness = JSON.parse(localStorage.getItem("user")).businesstype || "";
  
      // console.log( JSON.parse( localStorage.getItem( "user" ) ) );
      this.filterServices = {};
      this.filterServices.business = JSON.parse(localStorage.getItem("user")).businessid;
      this.filterServices.branch = JSON.parse(localStorage.getItem("user")).branch;
      
      if(this.win.meta?.accountingEntryToModify) {
        await this.setupvalues(this.win.meta.accountingEntryToModify);
      }
      this.loading = false;
      
      // Hacer scroll a la partida si se especificó
      if(this.win.meta?.scrollToEntry) {
        this.$nextTick(() => {
          this.scrollToAccountingEntry();
        });
      }
      // document.getElementById('jumper').addEventListener('keydown',this.checkTab);
      // window.addEventListener("keyup", this.validateEnterByCell);
     
      if(this.win.meta?.initEditable){
        this.enableEditing();
      } else {
        this.allowEditing = false;
      }
      
    } catch (error) {
      console.log(error)
    }
    //this.getAllAcounts();
  },
  methods: {
    // validateHabDeb( field, index ){
    //   if( this.AcountList[ index ].Deb > 0.00 &&
    //   if( field === 'Deb' ) { 
    //   } else if( field === 'Hab' ) {

    //   }
    // },
    async exportarPartidasDetalladas() {
      this.loading = true;
      let business = JSON.parse(localStorage.getItem('user')).business;
      let start = this.date;
      let end = this.date;
      const { data: result } = await this.$API.accountingentryheader.getAccountingItemsDetails(
        [ this.win.meta.accountingEntryToModify ]
      );

      this.print = {
          show: true,
          data: result,
          accounts: this.AccountListN,
          header: { business, start, end}
      }

      this.loading = false;
    },
    enableInput( currentElement ) {
      currentElement.classList.remove( "tableinput" );
      currentElement.removeAttribute( "readonly" );
      currentElement.classList.add( "tableinputeditable" );
    },
    disableInput( currentElement ) {
      currentElement.classList.remove( "tableinputeditable" );
      currentElement.setAttribute( "readonly", true );
      currentElement.classList.add( "tableinput" );
    },
    navigateThroughInputs( currentElement, direction ) {
      this.navigatingThroughInputs = true;
      const inputs = document.getElementById('detailstable').querySelectorAll('input,a')

      const currentIndex = Array.from( inputs ).indexOf( currentElement );

      let nextIndex = 0;
      if( currentIndex < inputs.length - 1 ) {  
        nextIndex = direction ? currentIndex + 1 : currentIndex - 1;
      } else {
        nextIndex = 0;
      }

      inputs.item( nextIndex ).focus();
      this.navigatingThroughInputs = false;
    },
    formatValuesOnBlur( index, property ) {
      const currentElement = { ...this.AcountList[ index ] };

      if( currentElement[ property ] === '' ) {
        currentElement[ property ] = 0;
      }
      currentElement[ property ] = parseFloat( currentElement[ property ] ).toFixed(2);

      if( currentElement[ property ] > 0 ) {
        currentElement.isDefault = false;
      }
      this.AcountList[ index ] = { ...currentElement };

      // Solo agrega un nuevo registro si el actual tiene código de cuenta y no es default
      if(
        currentElement.account_code &&
        !this.AcountList[ index + 1 ]?.account_code &&
        !this.AcountList[ index + 1 ]?.isDefault
      ) {
        this.AcountList.push( { ...this.defaultAccountItem } )
      }

      this.sums();
    },
    throughEvents( events, index ) {
      if( events ) {
        const arrayOfEventNames = Object.keys(events);
  
        const eventsObj = {}
  
        for( const eventName of arrayOfEventNames ) {
  
          eventsObj[ eventName ] = e => {
            events[ eventName ](index, e)
          };
        }
  
        return eventsObj
      }

      return {};
    },
    closeAccountsCatalog() {
      this.openCatalogByEnter = false;
      this.selectedToAssign = null;
    },
    isNotClearAccountEnabled() {
      return parseInt(JSON.parse(localStorage.getItem("user") || "{}")?.notclearaccount ?? 0) === 1;
    },
    isUseSugestAccountEnabled() {
      return parseInt(JSON.parse(localStorage.getItem("user") || "{}")?.usesugestaccount ?? 0) === 1;
    },
    isDetailedAccountingEntriesEnabled() {
      return parseInt(JSON.parse(localStorage.getItem("user") || "{}").detailedaccountingentries ?? 0) === 1;
    },
    preserveItemValuesWithAccount(index, accountData) {
      const currentItem = this.AcountList[index] || {};

      this.$set(this.AcountList, index, {
        ...currentItem,
        id_account: accountData.id_account,
        id: accountData.id_account,
        account_code: accountData.account_code,
        account_description: accountData.account_description,
        isDefault: false
      });
    },
    ensureDefaultAccountRow() {
      const last = this.AcountList[this.AcountList.length - 1];

      if (!last || last.account_code || !last.isDefault) {
        this.AcountList.push({ ...this.defaultAccountItem });
      }
    },
    closeAccountSuggestions() {
      this.accountSuggestionRowIndex = null;
      this.accountSuggestions = [];
      this.activeAccountSuggestionIndex = 0;
      this.accountSuggestionsStyle = {};
    },
    shouldShowAccountSuggestions() {
      return this.isUseSugestAccountEnabled()
        && this.accountSuggestionRowIndex !== null
        && this.accountSuggestions.length > 0
        && !this.cannotEdit;
    },
    setAccountSuggestionsPosition(inputElement) {
      if (!inputElement) return;

      const inputRect = inputElement.getBoundingClientRect();
      const maxWidth = Math.max(inputRect.width, 360);
      const availableRight = window.innerWidth - inputRect.left - 12;
      const suggestionHeight = Math.min(this.accountSuggestions.length * 38, 220);
      const top = Math.max(8, inputRect.top - suggestionHeight - 2);

      this.accountSuggestionsStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${inputRect.left}px`,
        width: `${Math.min(maxWidth, availableRight)}px`
      };
    },
    getAccountSuggestions(searchValue) {
      const filter = (searchValue || '').toString().trim().toLowerCase();

      if (!filter) return [];

      return this.AcountListN
        .filter((account) => {
          const code = (account.account_code || '').toString().toLowerCase();
          const name = (account.account_description || '').toString().toLowerCase();

          return account.SelectedItem && (code.includes(filter) || name.includes(filter));
        })
        .sort((first, second) => {
          const firstCode = (first.account_code || '').toString().toLowerCase();
          const secondCode = (second.account_code || '').toString().toLowerCase();
          const firstName = (first.account_description || '').toString().toLowerCase();
          const secondName = (second.account_description || '').toString().toLowerCase();
          const firstStarts = firstCode.startsWith(filter) ? 0 : 1;
          const secondStarts = secondCode.startsWith(filter) ? 0 : 1;
          const firstNameStarts = firstName.startsWith(filter) ? 0 : 1;
          const secondNameStarts = secondName.startsWith(filter) ? 0 : 1;

          if (firstStarts !== secondStarts) return firstStarts - secondStarts;
          if (firstNameStarts !== secondNameStarts) return firstNameStarts - secondNameStarts;
          return firstCode.localeCompare(secondCode);
        })
        .slice(0, 8);
    },
    updateAccountSuggestions(index, searchValue, inputElement = null) {
      if (!this.isUseSugestAccountEnabled()) {
        this.closeAccountSuggestions();
        return;
      }

      const suggestions = this.getAccountSuggestions(searchValue);

      if (suggestions.length === 0) {
        this.closeAccountSuggestions();
        return;
      }

      this.accountSuggestionRowIndex = index;
      this.accountSuggestions = suggestions;
      this.activeAccountSuggestionIndex = 0;
      this.setAccountSuggestionsPosition(inputElement);
    },
    moveAccountSuggestionFocus(direction) {
      if (!this.accountSuggestions.length) return;

      const lastIndex = this.accountSuggestions.length - 1;
      let nextIndex = this.activeAccountSuggestionIndex + direction;

      if (nextIndex < 0) nextIndex = lastIndex;
      if (nextIndex > lastIndex) nextIndex = 0;

      this.activeAccountSuggestionIndex = nextIndex;
    },
    handleAccountSuggestionKeydown(index, e) {
      if (this.accountSuggestionRowIndex !== index || this.accountSuggestions.length === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.moveAccountSuggestionFocus(1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.moveAccountSuggestionFocus(-1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        this.selectAccountSuggestion(index, this.accountSuggestions[this.activeAccountSuggestionIndex]);
        this.accountSuggestionSelectionPending = true;
      } else if (e.key === 'Escape') {
        this.closeAccountSuggestions();
      }
    },
    assignAccountToRow(index, accountData) {
      const currentItem = this.AcountList[index] || {};

      if (currentItem.id_account == accountData.id_account) {
        this.$set(this.AcountList, index, {
          ...currentItem,
          account_description: accountData.account_description
        });
        this.$forceUpdate()
        return;
      }

      if (this.isNotClearAccountEnabled()) {
        this.preserveItemValuesWithAccount(index, accountData);
        this.ensureDefaultAccountRow();
        this.$forceUpdate()
        return;
      }

      this.$set(this.AcountList, index, {
        id_accounting_entry_detail: currentItem.id_accounting_entry_detail,
        ...accountData,
        Hab: "0.00",
        Deb: "0.00",
        isDefault: false
      });

      this.ensureDefaultAccountRow();
      this.$forceUpdate()
    },
    selectAccountSuggestion(index, accountData) {
      if (!accountData) return;

      this.assignAccountToRow(index, accountData);
      this.closeAccountSuggestions();
    },
    deletebycell(e){
      // console.log('eliminando');
      // console.log(e.key);
      if(e.key == 'Enter'){
        // console.log(e.key, this.selectedToDelete);
        if(this.selectedToDelete) {
          this.confirmDeleteAccountingEntryDetail(this.selectedToDelete);
        }
      }
    },
    // validateEnterByCell(e) {
    //   try {
    //     if(e.key == 'Enter'){
    //       // if( this.deleteByEnter && !this.selectedToDelete.data.isDefault ) {
    //       //   this.confirmDeleteAccountingEntryDetail(this.selectedToDelete);
    //       // }
  
    //       if( this.openCatalogByEnter ) {
    //         this.chooseAccount( this.selectedToAssign );
    //       }
    //       // console.log(e.key, this.selectedToDelete);
    //       // if(this.selectedToDelete) {
    //       //   this.confirmDeleteAccountingEntryDetail(this.selectedToDelete);
    //       // }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    //   // console.log('eliminando');
    // },
    deleteeed(e){
      // console.log(e.columnIndex);
      if( e.columnIndex == 7 ){
        // console.log('aca');
        this.openCatalogByEnter = false;
        this.selectedToAssign = null;
        this.deleteByEnter = true;
        this.selectedToDelete = e.row;
      } else 
      if( e.columnIndex == 0 || e.columnIndex == 1 ) {
        // console.log('aquí');
        this.deleteByEnter = false;
        this.selectedToDelete = null;
        this.openCatalogByEnter = true;
        this.selectedToAssign = e.row;
      }
      // else {
      //   if( e.columnIndex != 7 ) {
      //   } else if( e.columnIndex != 0 || e.columnIndex != 1 ){
      //   }
      //   // this.preventEnterCounter = 0;
      //   // this.preventEnterCounter++;
      //   // if(this.preventEnterCounter > 1){
      //   // }
      // }
    },
    checkTab(event) {
 
      if (event.key === 'Tab') {
          event.preventDefault(); // Previene el comportamiento por defecto de la tecla Tab
          
          // this.$refs.detailsGrid.instance.focus();
      }
    },
 
    validateData(e) {
      // console.log(e.newData.account_code);
      // console.log(this.AcountListN);
      if(e.newData.account_code){
        const found = this.AcountListN.find( current => current.account_code === e.newData.account_code && current.SelectedItem );

        // console.log(found);
        if(found){
          // e.newData.newId_account = found.id_account;
          e.newData = {
            ...e.newData,
            ...found,
            Hab: 0.0,
            Deb: 0.0,
            isDefault: false
          };
          // const exist = this.AcountList.find(
          //   (item) => item.account_code == e.newData.account_code
          // );
          // if (exist) {
          //   e.cancel = true;
          //   this.showAlert("warning", "Error", "Ya existe una cuenta con el mismo código","" , "", false );
          //   return;
          // } else {
            this.AcountList.push( { ...this.defaultAccountItem } );
          // }
        }
        // else{
        //   e.cancel = true;
        //   this.showAlert("warning", "Error", "La cuenta ingresada no existe o no es candidata para crear un movimiento","" , "", false );
         
        // }
      }
    },
    accountCodeTyped(index){
      const { account_code, id_account } = this.AcountList[ index ];
      this.closeAccountSuggestions();

      if( account_code === '' || account_code === undefined ) {
        this.AcountList[ index ].account_code = '';
        this.AcountList[ index ].account_description = '';
        return;
      }

      const found = this.AcountListN.find( current => current.account_code === account_code && current.SelectedItem );

      if (!found) {
        this.showAlert("warning", "Error", `La cuenta ${account_code} no existe o no es candidata para crear un movimiento`,"" , "", false );
        this.AcountList[ index ].account_code = '';
        this.AcountList[ index ].account_description = '';
        return;
      }

      if(account_code && found && id_account != found.id_account) {
        this.assignAccountToRow(index, found);
      }

      if(account_code && found && id_account == found.id_account) {
        this.AcountList[index] = {
          ...this.AcountList[index],
          account_description: found.account_description
        };

        this.$forceUpdate()
      }
    },
    addAccount(){
      this.showModel = true;
      this.keyModel++;
      this.targetIndex = null;
    },
    chooseAccount(index) {
      // const { rowIndex } = data;
      this.showModel =true
      this.keyHistory++;
     
      //this.$refs.accountinghistory.createListener();
      this.targetIndex = index;
      // console.log(data);
    },
    getAcounteringType() {
      this.$API.branchaccountcatalog
        .getAcounteringType()
        .then((res) => {
          this.TypesItems = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAccountingDetailTypes() {
      this.$API.accountingentrydetailtype
        .getAccountingEntryDetailTypes()
        .then((res) => {
          this.detailTypes = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    canChangue(rowData) {
      if (rowData.type == "Debe") {
        return true;
      }
      return false;
    },
    confirmDeleteAccountingEntry() {
      this.showAlert(
        "question",
        "¿Está seguro de eliminar el la partida contable?",
        "Esta acción no se puede deshacer",
        "deleteAccountingEntry"
      );
    },
    confirmDeleteAccountingEntryDetail(index) {
      this.showAlert(
        "question",
        "¿Está seguro de eliminar el detalle?",
        "Esta acción no se puede deshacer",
        "deleteDetail",
        index
      );
    },
    confirmCleanAccountingEntryForm() {
      this.showAlert(
        "question2",
        "¿Está seguro de limpiar el formulario actual?",
        "Perderá los cambios no guardados",
        "clean"
      );
    },
   confirmDownloadCurrentEntryExcel() {
  this.showExcelConfirmDialog = true;
},
getTypeName(typeId) {
  const found = this.TypesItems.find(
    item => item.id_accounting_entry_type === typeId
  );
  return found ? found.accounting_entry_name : '';
},
    reaciveSelection(data) {
      // const { account_code } = data;
      this.showModel = false;
      // const exist = this.AcountList.find(
      //   (item) => item.account_code == account_code
      // );
      // if (exist) {
      //   this.showAlert("danger", "Error", "Ya existe una cuenta con el mismo código");
      //   return;
      // }
      if(typeof this.targetIndex != 'number') {
        this.AcountList.pop();
        this.AcountList.push( { ...data, ...this.defaultAccountItem, isDefault: false } );
        this.AcountList.push( { ...this.defaultAccountItem } );
      } else {
        if (this.isNotClearAccountEnabled()) {
          this.preserveItemValuesWithAccount(this.targetIndex, data);
          this.ensureDefaultAccountRow();
          this.targetIndex = null;

          if( this.openCatalogByEnter ) {
            this.openCatalogByEnter = false;
            this.selectedToAssign = null;
          }

          this.$forceUpdate();
          return;
        }

        this.AcountList.pop();
        this.AcountList[ this.targetIndex ] = {
          ...this.AcountList[ this.targetIndex ],
          ...data,
          ...this.defaultAccountItem,
          isDefault: false
        };
        this.AcountList.push( { ...this.defaultAccountItem } );
        this.targetIndex = null;

        if( this.openCatalogByEnter ) {
          this.openCatalogByEnter = false;
          this.selectedToAssign = null;
        }
      }
    },
    sums() {
      this.Totals.TotalDebe = this.SumDeb();
      this.Totals.TotalHaber = this.SumHab();
      this.Totals.Total = this.TotalAcount();
    },
    SumDeb() {
      let x = 0;
      if (this.AcountList.length == 0) {
        return 0;
      }

      this.AcountList.forEach((element) => {
        x += +element.Deb;
      });
      if (typeof x == "string" || isNaN(x)) {
        x = 0;
      }
      return x.toFixed(2);
    },
    SumHab() {
      let x = 0;
      if (this.AcountList.length == 0) {
        return 0;
      }

      if (this.AcountList[0].Hab == null) return 0;
      this.AcountList.forEach((element) => {
        x += +element.Hab;
      });
      if (typeof x == "string" || isNaN(x)) {
        x = 0;
      }
      return x.toFixed(2);
    },
    TotalAcount() {
      return (this.SumDeb() - this.SumHab()).toFixed(2);
    },
    getTotals(e) {
      try {
        this.logEvent(e);
        if(e.cancel)
        
        // e.data.Hab = e.data.Hab.toFixed(2)
        // e.data.Deb = e.data.Deb.toFixed(2)
        this.Totals.TotalDebe = this.SumDeb();
        this.Totals.TotalHaber = this.SumHab();
        this.Totals.Total = this.TotalAcount();
        
      } catch (error) {
        console.log(error);
      }
    },
    changueD(date) {
      this.date = date;
      moment.locale('es');
  
      const selectedDate = moment( this.date, 'DD/MM/YYYY' );

      this.$API.accountlevel.getLastAcountingCorrelative({
        monthToFind: selectedDate.month() + 1,
        yearToFind: selectedDate.year()
      }).then( result => {
        this.lastAccountingCorrelative = result.data?.ID_Accounting_item;
      }).catch( error => {
        console.log(error);
      });
    },
    async getAllAcounts() {
      try {
        const result = await this.$API.branchaccountcatalog.getActiveBranchAccountCatalog();
        this.AcountListN = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    onEditingStart(e) {
      if (!this.editableFieldsList.includes(e.column.dataField)) {
        e.cancel = true;
      }
    },
    logEvent(e) {
      e.data.Hab = parseFloat(e.data.Hab).toFixed(2)
      e.data.Deb = parseFloat(e.data.Deb).toFixed(2);
      // if ( e.data.Hab != 0.00 && e.data.Deb != 0.00)
      // {
      //   this.showAlert("danger", "Error", "No puede tener un valor en debe y haber");
      //   e.cancel = true;
      //   return;
      // }
    },
    onExporting(e) {
      printToExcel(e, "Servicios");
    },

    formatAccounts() {
      for (const index in this.AcountList) {
        this.AcountList[index].id = this.AcountList[index].id_account;
      }
    },
    closeAlert() {
      this.alert.show = false;
    },
    async acceptAlert() {
      this.alert.show = false;

      const { data, options } = this.alert;

      if (this._resolveContinue) {
        this._resolveContinue(true);
        this._resolveContinue = null;
        return;
      }
      
      if (typeof data === 'undefined') {
        await this[options]();
      } else {
        await this[options](data);
      }
    },
    showAlert(type, header, body, options = null, data = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
      this.alert.data = data != null ? data : null;
    },
    deleteDetail(index) {
      // console.log(index);
      if (this.editing) {
        this.RemovedAccountList.push(this.AcountList[index]);
      }
      this.AcountList.splice(index, 1);

      // console.log(this.AcountList)

      if(this.AcountList.length === 0) {
        this.AcountList.push( { ...this.defaultAccountItem } );
      }

      // console.log(this.AcountList)
      if( this.selectedToDelete ) {
        this.selectedToDelete = null;
        this.deleteByEnter = false;
      }
    },

    closeDialog() {
      this.serviceToDelete = null;
      this.editService = false;
      this.showModel = false;
      this.deleteDialog = false;
    },
    async setupvalues(data) {
      this.clean();
      
      this.loading = true;

      try {
        this.showHistory = false;
        // console.log(data);
        // console.log( data.accounting_entry_date)
        this.editing = true;

        this.$emit( 'updatingAccountingEntry', data.ID_Accounting_item );

        const { data: { accountingEntry, accountingEntryDetails } } = await this.$API.accountingentryheader.getOneAcountingHeader( data.id_accounting_entry );


        this.form.ID_Accounting_item = accountingEntry.ID_Accounting_item;
        this.form.id_accounting_entry = accountingEntry.id_accounting_entry;
        this.date = moment( new Date( accountingEntry.accounting_entry_date ) ).format( 'DD/MM/YYYY' );
        this.form.concept = accountingEntry.accounting_entry_comment;
        this.form.type = accountingEntry.id_accounting_entry_type;
        const details = [];
        
        accountingEntryDetails.map((item) => {
          // console.log(item);
          const index = this.AcountListN.find(
            (current) => current.id_account == item.id_account
          );
  
          item.account_code = index.account_code;
          item.account_description = index.account_description;
  
          if (item.id_entry_detail_type == 2) {
            item.Deb = item.amount;
            item.Hab = 0;
          } else if (item.id_entry_detail_type == 1) {
            item.Hab = item.amount;
            item.Deb = 0;
          }
  
          details.push(item);
        });
        // console.log(details, 'detalle');
        this.AcountList = [ ...details ];
        this.formatAccounts();
      } catch (error) {
        console.log( error );
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async deleteAccountingEntry() {
      const { id_accounting_entry } = this.form;
      try {
        this.loading = true;
        const {
          message,
          id_accounting_entry: responded_id_accounting_entry,
        } = await this.$API.accountingentryheader.deleteAccountingEntryHeader({
          accountingentry: { id_accounting_entry },
        });

        this.showAlert(
          "successWithCallback",
          "Registro Eliminado",
          `${message} ID: ${responded_id_accounting_entry}`,
          "clean",
        );
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.showAlert(
          "danger",
          "Error",
          `Ocurrió el siguiente error al intentar eliminar los datos de la partida ${id_accounting_entry} ${error.message}`
        );

      }
    },
    removeEmptyItemsFromList(list) {
      for (let i = list.length - 1; i >= 0; i--) {
        if (!('id_account' in list[i])) {
          list.splice(i, 1);
        }
      }
    },
    async saveAccountingEntry() {
      try {
        if (!this.valid) {
          this.showAlert("danger", "Error", "Debe llenar todos los campos");
          return;
        }
        this.loading = true;
        // this.AcountList.pop();
        this.removeEmptyItemsFromList(this.AcountList);
        this.sums();
        // console.log('this.AcountList ', this.AcountList);
        // this.$refs.detailsGrid.instance.saveEditData();

        // console.log("guardando");

        if (this.AcountList.length === 0 || (this.AcountList.length === 1 && this.AcountList[0].isDefault)) {
          this.showAlert(
            "danger",
            "Error",
            "Debe agregar al menos un detalle a la partida contable antes de guardar."
          );
          this.loading = false;
          return;
        }
        
        const hasTransaction = this.AcountList.filter(
          (current) => current.Deb === 0 && current.Hab === 0
        );

        if (hasTransaction.length > 0) {
          this.showAlert(
            "danger",
            "Error",
            "La partida no debe contener registros que no posean Debe o Haber"
          );
          this.AcountList.push( { ...this.defaultAccountItem } );
          this.loading = false;
          return;
        }

        let someInvalidAccount = '';
        
        for( const element of this.AcountList ) {
          const { account_code } = element;
          const found = this.AcountListN.find( current => current.account_code === account_code && current.SelectedItem );
          if(!found){
            someInvalidAccount = account_code
          }
        }

        if(someInvalidAccount.length > 0) {
          this.showAlert("warning", "Error", `La cuenta ${someInvalidAccount} no existe o no es candidata para crear un movimiento`,"" , "", false );
          this.loading = false;
          return;
        }

        const invalidTransaction = this.AcountList.filter(
          current => current.Deb > 0 && current.Hab > 0
        )

        if(invalidTransaction.length > 0) {
          this.showAlert(
            "danger",
            "Error",
            "Los detalles de la partida deben de tener un monto asignado en Debe o en Haber, no ambos"
          );
          this.AcountList.push( { ...this.defaultAccountItem } );
          this.loading = false;
          return;
        }

        for (const index in this.AcountList) {
          if (this.AcountList[index].Deb > 0) {
            this.AcountList[index].id_entry_detail_type = this.detailTypes.find(
              (current) => current.entry_detail_type_description === "DEBER"
            ).id_entry_detail_type;
            this.AcountList[index].amount = this.AcountList[index].Deb;
          } else if (this.AcountList[index].Hab > 0) {
            this.AcountList[index].id_entry_detail_type = this.detailTypes.find(
              (current) => current.entry_detail_type_description === "HABER"
            ).id_entry_detail_type;
            this.AcountList[index].amount = this.AcountList[index].Hab;
          }
        }

        for (const detalle of this.AcountList) {
          if (!detalle.id_entry_detail_type) {
            this.showAlert(
              "danger",
              "Error",
              "Todos los detalles deben tener un tipo de movimiento (Debe/Haber) asignado."
            );
            this.AcountList.push({ ...this.defaultAccountItem });
            this.loading = false;
            return;
          }
        }
        
        const { type, concept, ID_Accounting_item, correlative } = this.form;

        

        if (!this.editing) {
          const payload = {
            accountingentry: {
              ID_Accounting_item: ID_Accounting_item ? ID_Accounting_item : null,
              id_accounting_entry_type: type,
              accounting_entry_date: new Date( formatDateV2( this.date ) ),
              accounting_entry_comment: concept,
              accounting_entry_value: this.AcountList.reduce(
                ( accumulator, currentValue ) => {
                  const { Deb } = currentValue;
                  const valueToAccum = parseFloat(Deb);
                  // console.log('Deb ', typeof Deb);
                  // console.log('accumulator ', accumulator);
                  if (valueToAccum > 0) {
                    return accumulator + valueToAccum;
                  } else {
                    return accumulator;
                  }
                },
                0.0
              ),
              accountingentrydetails: this.AcountList.map((current) => {
                const { id_account, id_entry_detail_type, amount, concept } = current;
                return {
                  id_account,
                  id_entry_detail_type,
                  amount,
                  concept
                };
              }),
            },
          };

          if (this.Totals.Total != 0 && this.Totals.Total != '0.00') {
            this.loading = false;
            this.AcountList.push({ ...this.defaultAccountItem });
            const continuar = await this.askUserToContinue();
            if (!continuar) {
              return;
            }
            this.loading = true;
          }
          

          await this.$API.accountingentryheader.createAccountingEntryHeader(
            payload
          );
          
        } else {
          const { id_accounting_entry } = this.form;

          this.removeEmptyItemsFromList(this.RemovedAccountList);
          const entryDetails = [
            ...this.AcountList.map((current) => {
              const {
                id_accounting_entry_detail,
                id_account,
                id_entry_detail_type,
                amount,
                concept: detailConcept,
              } = current;
              return {
                id_accounting_entry_detail,
                id_account,
                id_entry_detail_type,
                concept: detailConcept,
                amount,
              };
            }),
            ...this.RemovedAccountList.map((current) => {
              const { id_accounting_entry_detail } = current;
              return {
                id_accounting_entry_detail,
                removed: true,
              };
            }),
          ];

          const payload = {
            accountingentry: {
              id_accounting_entry,
              id_accounting_entry_type: type,
              accounting_entry_date: new Date(formatDateV2(this.date)),
              accounting_entry_comment: concept,
              accounting_entry_value: this.AcountList.reduce(
                (accumulator, currentValue) => {
                  const { Deb } = currentValue;
                  if (Deb > 0) {
                    return accumulator + parseFloat( Deb );
                  } else {
                    return accumulator;
                  }
                },
                0.0
              ),
              accountingentrydetails: [...entryDetails],
            },
          };

          if(correlative) {
            payload.accountingentry.correlative = this.getCorrelative(correlative);
          }
          
          if (this.Totals.Total != 0 && this.Totals.Total != '0.00') {
            this.loading = false;
            this.AcountList.push({ ...this.defaultAccountItem });
            const continuar = await this.askUserToContinue();
            if (!continuar) {
              return;
            }
            this.loading = true;
          }

          await this.$API.accountingentryheader.updateAccountingEntryHeader(
            payload
          );
        }
        this.showAlert(
          "successWithCallback",
          "Registro guardado",
          `Se guardaron los datos de la partida contable correctamente`,
          "clean"
        );
        this.loading = false;
      } catch (error) {
        this.AcountList.push( { ...this.defaultAccountItem } );
        this.loading = false;
        this.showAlert(
          "dangerHtml",
          "Error",
          `Ocurrió el siguiente error al intentar guardar los datos: <br/> ${error.message}`
        );
      }
    },
    async getDetailedAccountingRows(itemsOrdenados) {
      const accountIds = [...new Set(
        itemsOrdenados
          .map(item => Number(item.id_account))
          .filter(id => Number.isInteger(id))
      )];
      const result = await this.$API.branchaccountcatalog.getAccountHierarchy({ accountIds });
      const accountsById = new Map((result.data || []).map(account => [Number(account.id_account), account]));
      const rows = [];

      itemsOrdenados.forEach((item) => {
        const accountChain = [];
        const visited = new Set();
        let current = accountsById.get(Number(item.id_account));

        while (current && !visited.has(Number(current.id_account))) {
          visited.add(Number(current.id_account));
          accountChain.unshift(current);
          current = accountsById.get(Number(current.id_parent));
        }

        const leafCode = String(item.account_code || '');
        const prefixParents = [...accountsById.values()]
          .filter(account => {
            const accountCode = String(account.account_code || '');
            return accountCode !== leafCode && leafCode.startsWith(accountCode);
          })
          .sort((first, second) => String(first.account_code).length - String(second.account_code).length);

        if (prefixParents.length > 0) {
          accountChain.splice(0, accountChain.length, ...prefixParents, accountsById.get(Number(item.id_account)) || item);
        }

        const parentAccounts = accountChain.slice(0, -1);
        parentAccounts
          .filter(account => String(account.account_code || '').length >= 4)
          .forEach((account, accountIndex) => {
          rows.push({
            cuenta: account.account_code || '',
            concepto: account.account_description || '',
            debe: '',
            haber: '',
            isInitialNonMovementAccount: accountIndex === 0 && Number(account.allow_transactions || 0) === 0
          });
        });

        rows.push({
          cuenta: item.account_code || '',
          concepto: item.account_description || '',
          debe: item.Deb && parseFloat(item.Deb) > 0 ? parseFloat(item.Deb).toLocaleString('en-US', { minimumFractionDigits: 2 }) : '',
          haber: item.Hab && parseFloat(item.Hab) > 0 ? parseFloat(item.Hab).toLocaleString('en-US', { minimumFractionDigits: 2 }) : '',
          isInitialNonMovementAccount: false
        });

        if (item.concept && item.concept.trim() !== '' && item.concept !== item.account_description) {
          rows.push({ cuenta: '', concepto: item.concept, debe: '', haber: '' });
        }
      });

      return rows;
    },
    async exportPdf() {
      this.loading = true;
      try {
        let branch = JSON.parse(localStorage.getItem("user")).branch;
        let business = JSON.parse(localStorage.getItem("user")).businessid;
        let [businessInfo] = await this.$API.branches.findSpecificBranch({ branch, business });

        let items = this.AcountList ? [...this.AcountList] : [];
        let accountingInfo = {
          ...this.form,
          date: this.date,
          type: this.form.type,
          typeName: this.getTypeName(this.form.type),
          concept: this.form.concept,
          ID_Accounting_item: this.form.ID_Accounting_item
        };

        let itemsDebe = items.filter(item => parseFloat(item.Deb) > 0);
        let itemsHaber = items.filter(item => parseFloat(item.Hab) > 0);
        let itemsOrdenados = [...itemsDebe, ...itemsHaber];

        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const pdfMargin = 14;
        const headerLineHeight = 4.5;
        const conceptText = `Concepto: ${accountingInfo.concept || ''}`;
        const typeText = accountingInfo.typeName ? ` ${accountingInfo.typeName}` : '';
        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        const conceptLines = doc.splitTextToSize(conceptText, pageWidth - (pdfMargin * 2));
        const tableStartY = accountingInfo.ID_Accounting_item
          ? 30 + (conceptLines.length * headerLineHeight) + 8
          : 30;
        let y = tableStartY; // Start after header space

        // Construcción de filas
        const detailedAccountingEntries = this.isDetailedAccountingEntriesEnabled();
        let rows = detailedAccountingEntries
          ? await this.getDetailedAccountingRows(itemsOrdenados)
          : [];

        if (!detailedAccountingEntries) {
          itemsOrdenados.forEach((item) => {
            rows.push({
              cuenta: item.account_code || '',
              concepto: item.account_description || '',
              debe: item.Deb && parseFloat(item.Deb) > 0 ? parseFloat(item.Deb).toLocaleString('en-US', { minimumFractionDigits: 2 }) : '',
              haber: item.Hab && parseFloat(item.Hab) > 0 ? parseFloat(item.Hab).toLocaleString('en-US', { minimumFractionDigits: 2 }) : ''
            });
            if (item.concept && item.concept.trim() !== '' && item.concept !== item.account_description) {
              rows.push({ cuenta: '', concepto: item.concept, debe: '', haber: '' });
            }
          });
        }

        const totalDebe = items.reduce((acc, cur) => acc + (parseFloat(cur.Deb) || 0), 0);
        const totalHaber = items.reduce((acc, cur) => acc + (parseFloat(cur.Hab) || 0), 0);
        rows.push({
          cuenta: '',
          concepto: 'Total Partida',
          debe: totalDebe.toLocaleString('en-US', { minimumFractionDigits: 2 }),
          haber: totalHaber.toLocaleString('en-US', { minimumFractionDigits: 2 })
        });

        autoTable(doc, {
          startY: y,
          head: [['Cuenta', 'Concepto', 'Debe', 'Haber']],
          body: rows.map(row => [row.cuenta, row.concepto, row.debe, row.haber]),
          styles: { fontSize: 9, cellPadding: 1.5, lineWidth: 0 },
          headStyles: { textColor: 0, lineWidth: 0.1 },
          bodyStyles: { valign: 'top' },
          theme: 'plain',
          margin: { top: tableStartY, bottom: 20 },
          columnStyles: {
            0: { cellWidth: 'auto', halign: 'left' },
            1: { cellWidth: 'auto', halign: 'left' },
            2: { cellWidth: 24, halign: 'right' },
            3: { cellWidth: 24, halign: 'right' }
          },
          didDrawPage: function (data) {
            
            var headerTop = 10;
            if (data.pageNumber == 1) {
  
              doc.setFontSize(13);
              doc.setFont(undefined, 'bold');
              doc.text(businessInfo?.BusinessName || '', pageWidth / 2, headerTop, { align: 'center' });
  
              doc.setFontSize(11);
              doc.setFont(undefined, 'normal');
              headerTop += 6;
              doc.text('Partida Contable', pageWidth / 2, headerTop, { align: 'center' });
            }

            if (accountingInfo.ID_Accounting_item) {
              doc.setFontSize(9);
              doc.setFont(undefined, 'bold');
              headerTop += 8;
              const accountingItemText = `Partida #: ${accountingInfo.ID_Accounting_item}${typeText ? ` - ${typeText}` : ''}`;
              doc.text(accountingItemText, pdfMargin, headerTop);
              doc.text(`Fecha: ${accountingInfo.date}`, pageWidth - pdfMargin, headerTop, { align: 'right' });

              headerTop += 8;
              doc.text(conceptLines, pdfMargin, headerTop);
            }

            // Número de página
            const pageCount = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.text(`Página ${data.pageNumber} de ${pageCount}`, pageWidth - 20, pageHeight - 8, { align: 'right' });
          },
          didParseCell: function (data) {
            const rowData = rows[data.row.index];

            if (rowData && rowData.isInitialNonMovementAccount) {
              data.cell.styles.fontStyle = 'bold';
            }
          },
          willDrawCell: function (data) {
            const rowData = rows[data.row.index];

            if (data.column.dataKey === 'cuenta' || data.column.dataKey === 'concepto') {
              data.cell.styles.valign = 'top';
            }

            // Última fila: total
            if (data.row.index === rows.length - 1) {
              doc.setFontSize(10).setFont(undefined, 'bold');
              if (data.column.index === 1) {
                data.cell.styles.halign = 'right';
              }
            }

            if (rowData && rowData.cuenta === '' && rowData.concepto && rowData.debe === '' && rowData.haber === '' && data.row.index < rows.length - 1) {
              data.cell.styles.cellPadding = { top: 0, right: 1.5, bottom: 1.5, left: 1.5 };
              data.cell.styles.textColor = [255, 0, 0];
            }
          }
        });

        // Calcular espacio disponible para firmas
        const idealSpace = 40;      // Espacio ideal entre tabla y firmas
        const minSpace = 15;         // Espacio mínimo aceptable
        const bottomMargin = 10;     // Margen inferior de la página
        
        let currentY = doc.lastAutoTable.finalY;
        const totalSpaceAvailable = pageHeight - currentY - bottomMargin;
        
        // Decidir el espacio a usar según disponibilidad
        if (totalSpaceAvailable >= idealSpace) {
          // Hay espacio ideal, usar 40mm
          currentY += idealSpace;
        } else if (totalSpaceAvailable >= minSpace) {
          // No hay espacio ideal pero sí mínimo, reducir a 15mm para mantener en misma página
          currentY += minSpace;
        } else {
          // No hay espacio suficiente, crear nueva página con espacio ideal
          doc.addPage();
          currentY = 40;
        }

        // Dibujar las firmas
        doc.setFontSize(10);
        doc.text('HECHO POR', 20, currentY);
        doc.text('REVISADO POR', pageWidth / 2, currentY, { align: 'center' });
        doc.text('AUTORIZADO POR', pageWidth - 20, currentY, { align: 'right' });

        window.open(doc.output('bloburl'));
      } catch (error) {
        this.showAlert('danger', 'Error', 'No se pudo exportar el PDF: ' + error.message);
      } finally {
        this.loading = false;
      }
    },
    enableEditing() {
      this.allowEditing = true;
      this.AcountList.push( { ...this.defaultAccountItem } );
    },
    duplicateAccountingItem() {
      this.editing = false;
      this.form.ID_Accounting_item = '';
      this.$emit( 'updatingAccountingEntry', '' );
    },
    clean(example = true) {

  const oldLink = document.getElementById('import-error-link');
  if (oldLink) oldLink.remove();

  this.form = {
    concept: "",
    type: null,
  };

  const date = this.date;

  this.$refs.accountingEntryForm.reset();
  this.date = null;
  this.editing = false;
  this.allowEditing = false;

  if (example === true || example === null || example === undefined) {
    this.AcountList = [{ ...this.defaultAccountItem }];
  }

  this.RemovedAccountList = [];
  this.$nextTick(() => { this.date = date });

  this.alert = { ...this.defaultAlert };
},
    getCorrelative(value) {
      let newVal = value;
      if(newVal.length < 6) {
        for(let i = newVal.length; i < 6; i++) {
          //console.log(newVal);
          newVal = '0' + newVal;
        }
      }
      const arrayDate = this.date.split("/");
      this.form.ID_Accounting_item = `PC${arrayDate[2] + arrayDate[1] + newVal}`;
      //console.log(this.form.ID_Accounting_item);
      return this.form.ID_Accounting_item;
    },
    triggerExcelImport() {
  this.$refs.excelInput.click();
},

async handleExcelImport(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
// 🔎 VALIDAR FORMATO DE PLANTILLA
const requiredColumns = ["Cuenta", "Nombre", "Concepto", "DEBE", "HABER"];

const sheetHeaders = Object.keys(jsonData[0] || {});

const isValidFormat = requiredColumns.every(col =>
  sheetHeaders.includes(col)
);

if (!isValidFormat) {
  this.showAlert(
    "danger",
    "Error",
    "La plantilla a importar no cumple el formato requerido. Favor descargue la plantilla oficial del sistema para comparar."
  );
  return;
}

      const notImported = [];
      const imported = [];

      const parseNumber = (value) => {
        if (value === '' || value === null || value === undefined) return '';
        return parseFloat(
          value.toString().replace(/,/g, '').trim()
        ) || '';
      };

      jsonData.forEach((row) => {

        const accountCode = row.Cuenta
          ? row.Cuenta.toString().trim()
          : null;

        if (!accountCode) return;

        const found = this.AcountListN.find(
          acc =>
            acc.account_code === accountCode &&
            acc.SelectedItem
        );

        const DebRaw = row.DEBE ?? '';
        const HabRaw = row.HABER ?? '';

        const Deb = parseNumber(DebRaw);
        const Hab = parseNumber(HabRaw);

        if (!found) {
          notImported.push({
            Cuenta: row.Cuenta || '',
            Nombre: row.Nombre || '',
            Concepto: row.Concepto || '',
            Debe: DebRaw,
            Haber: HabRaw,
            Motivo: 'Cuenta no existe en catálogo'
          });
          return;
        }

        imported.push({
          id_account: found.id_account,
          account_code: found.account_code,
          account_description: found.account_description,
          concept: row.Concepto || '',
          Deb: Deb === '' ? 0 : Deb,
          Hab: Hab === '' ? 0 : Hab,
          isDefault: false
        });

      });

      if (imported.length > 0) {
        this.AcountList = [
          ...imported,
          { ...this.defaultAccountItem }
        ];
        this.$forceUpdate();
      }

      let downloadUrl = null;

      if (notImported.length > 0) {
        const ws = XLSX.utils.json_to_sheet(notImported);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          ws,
          'Cuentas no importadas'
        );

        const wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          type: 'array'
        });

        const blob = new Blob([wbout], {
          type: 'application/octet-stream'
        });

        downloadUrl = URL.createObjectURL(blob);
      }

      if (notImported.length === 0) {

  this.showAlert(
    "successWithCallback",
    "Importación exitosa",
    "Todas las cuentas fueron importadas correctamente"
  );

} else {

  this.showAlert(
    "warning",
    "Importación parcial",
    `Se importaron ${imported.length} cuentas correctamente.
${notImported.length} cuentas no fueron importadas.`
  );

}


      if (downloadUrl) {
        this.$nextTick(() => {
          setTimeout(() => {

            const oldLink = document.getElementById('import-error-link');
            if (oldLink) oldLink.remove();

            const container = document.querySelector('.v-card__text');
            if (!container) return;

            const link = document.createElement('a');
            link.id = 'import-error-link';
            link.href = downloadUrl;
            link.download = 'Cuentas_No_Importadas.xlsx';
            link.innerText = 'Descargar detalle de cuentas no importadas';
            link.style.display = 'block';
            link.style.marginTop = '15px';
            link.style.color = 'red';
            link.style.fontWeight = 'bold';

            container.appendChild(link);

          }, 100);
        });
      }

    } catch (error) {
      console.error('Error en importación:', error);
      this.showAlert(
        'danger',
        'Error',
        'Ocurrió un error al procesar el archivo.'
      );
    }
  };

  reader.readAsArrayBuffer(file);
  event.target.value = '';
},
downloadCurrentEntryExcel(includeHeader = false) {

  try {

    const validRows = this.AcountList.filter(
      item => item.account_code && !item.isDefault
    );

    if (validRows.length === 0) {
      this.showAlert(
        "warning",
        "Sin datos",
        "No hay registros para exportar."
      );
      return;
    }

    const dataToExport = validRows.map(item => ({
      Cuenta: item.account_code || '',
      Nombre: item.account_description || '',
      Concepto: item.concept || '',
      DEBE: item.Deb > 0 ? parseFloat(item.Deb).toFixed(2) : '',
      HABER: item.Hab > 0 ? parseFloat(item.Hab).toFixed(2) : ''
    }));

    let worksheet;

    if (includeHeader) {

      const headerRows = [
        [`Correlativo: ${this.form.ID_Accounting_item || ''}`],
        [`Fecha: ${this.date || ''}`],
        [`Concepto: ${this.form.concept || ''}`],
        [`Tipo: ${this.getTypeName(this.form.type) || ''}`],
        [],
      ];

      worksheet = XLSX.utils.aoa_to_sheet(headerRows);

      XLSX.utils.sheet_add_json(
        worksheet,
        dataToExport,
        { origin: "A6" }
      );

    } else {

      worksheet = XLSX.utils.json_to_sheet(dataToExport);

    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Partida");

    const fileName = this.form.ID_Accounting_item
      ? `Partida_${this.form.ID_Accounting_item}.xlsx`
      : "Partida_Contable.xlsx";

    XLSX.writeFile(workbook, fileName);

  } catch (error) {

    this.showAlert(
      "danger",
      "Error",
      "No se pudo generar el archivo Excel."
    );

  }
},
downloadExcelTemplate() {

  const headers = [
    {
      Cuenta: '',
      Nombre: '',
      Concepto: '',
      DEBE: '',
      HABER: ''
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(headers);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    'Plantilla'
  );

  XLSX.writeFile(workbook, 'Plantilla_Partida_Contable.xlsx');
},
showImportErrors(failedAccounts) {
  const worksheet = XLSX.utils.json_to_sheet(failedAccounts);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Cuentas no importadas");

  const fileName = "Cuentas_No_Importadas.xlsx";
  XLSX.writeFile(workbook, fileName);

  this.showAlert(
    "warning",
    "Importación parcial",
    `Se importaron ${this.AcountList.length - 1} cuentas correctamente.
     ${failedAccounts.length} cuentas no fueron importadas.
     Se descargó automáticamente un archivo con el detalle.`
  );
},
    askUserToContinue() {
      return new Promise((resolve) => {
        const noSaveUnadjustedItems = JSON.parse(localStorage.getItem("user")).nosaveunadjusteditems || 0

        if (noSaveUnadjustedItems) {
          this.showAlert(
            "warning",
            "Advertencia",
            "No se puede guardar, favor cuadrar la partida"
          )
        }
        else {
          this.showAlert(
            "question2",
            "¿Desea guardar de todas formas?",
            `Existe una diferencia de ${this.Currency}${this.Totals.Total}. ¿Desea guardar de todas formas?`,
            "saveWithDifference"
          );
          // Guardamos el resolve para llamarlo después
          this._resolveContinue = resolve;
        }
      });
    },
    confirmDownloadWithHeader() {
  this.showExcelConfirmDialog = false;
  this.downloadCurrentEntryExcel(true);
},

confirmDownloadWithoutHeader() {
  this.showExcelConfirmDialog = false;
  this.downloadCurrentEntryExcel(false);
},

  },
};
</script>

<style scoped>
.close-icon {
  color: red;
}

.btnsave {
  background-color: #00a178 !important;
  color: white;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}
.text-black {
  color: black;
}
.centered {
  display: flex;
  justify-content: center;
}

.bar {
  width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin-top: 1rem !important;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.tableinput:focus {
  border: 1px solid black;
}

.tableinputeditable:focus {
  border: 1px solid rgb(17, 0, 255);
}

.account-code-cell {
  position: relative;
}

.account-suggestions {
  z-index: 9999;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18);
}

.account-suggestion-item {
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 10px;
  border: 0;
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
}

.account-suggestion-item:last-child {
  border-bottom: 0;
}

.account-suggestion-item:hover,
.account-suggestion-active {
  background: #e8f0fe;
}

.account-suggestion-code {
  min-width: 92px;
  font-weight: 700;
  color: #1f2937;
}

.account-suggestion-name {
  color: #374151;
  line-height: 1.25;
}
/* tr:nth-child(even) {
  background-color: #dddddd;
} */
</style>
